import { Component, OnInit } from '@angular/core';
import { MERIT_LIST_DATA } from './merit-list-data';

interface Student {
  sNo: string;
  rollNo: string;
  name: string;
  fatherName: string;
  obtainedMarks?: string;
  maxMarks?: string;
  percentage?: string;
  cells: string[];
}

interface CourseSection {
  courseName: string;
  hasMerit: boolean;
  headers: string[];
  students: Student[];
}

interface SessionData {
  session: string;
  courses: CourseSection[];
}

@Component({
  selector: 'app-meritorious-students',
  templateUrl: './meritorious-students.component.html',
  styleUrls: ['./meritorious-students.component.scss']
})
export class MeritoriousStudentsComponent implements OnInit {

  // Source document file path (View-only on website, no download option)
  excelFilePath: string = 'assets/excel/Merit List 2017-25.xlsx';
  
  sessions: SessionData[] = MERIT_LIST_DATA;
  activeSessionName: string = '';
  searchTerm: string = '';

  constructor() { }

  ngOnInit(): void {
    if (this.sessions && this.sessions.length > 0) {
      // Default to the latest session (e.g. Session 2024-25)
      this.activeSessionName = this.sessions[this.sessions.length - 1].session;
    }
  }

  setSession(sessionName: string): void {
    this.activeSessionName = sessionName;
  }

  get currentSession(): SessionData | undefined {
    return this.sessions.find(s => s.session === this.activeSessionName);
  }

  get filteredCourses(): CourseSection[] {
    const session = this.currentSession;
    if (!session) return [];

    if (!this.searchTerm || !this.searchTerm.trim()) {
      return session.courses;
    }

    const query = this.searchTerm.trim().toLowerCase();

    return session.courses.map(course => {
      const courseMatch = course.courseName.toLowerCase().includes(query);
      const matchingStudents = course.students.filter(student =>
        student.name.toLowerCase().includes(query) ||
        student.rollNo.toLowerCase().includes(query) ||
        student.fatherName.toLowerCase().includes(query)
      );

      if (courseMatch) {
        return course;
      } else if (matchingStudents.length > 0) {
        return {
          ...course,
          students: matchingStudents
        };
      } else {
        return null;
      }
    }).filter((course): course is CourseSection => course !== null);
  }

  getTotalStudentsCount(session: SessionData): number {
    return session.courses.reduce((acc, course) => acc + (course.students ? course.students.length : 0), 0);
  }

  isPercentageCol(headerName: string): boolean {
    if (!headerName) return false;
    const h = headerName.toLowerCase();
    return h.includes('%') || h.includes('percentage');
  }

  formatPercentageDisplay(val: string): string {
    if (!val) return '';
    return val.endsWith('%') ? val : `${val}%`;
  }

}


